module.exports = __webpack_public_path__ + "img/activity1.3deede16.png";